var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog206(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_206"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_206",
    "data-name": 206,
    className: "cls-2",
    d: "M47,4.56C36.77-1.1,23.62,2.25,19.22,17.05,15,31.18,23,47.6,29.18,59.54c6.27,12.15,14.14,29.79,25.75,36,11.36,6.1,29.94-.52,27.26-17.06-2.48-15.32-8.42-29.66-14.94-43.28C62.19,24.67,57,10.07,47,4.56Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog206);
export default __webpack_public_path__ + "static/media/dog_206.e491135c71e2ed62ce7555bf39ceaf29.svg";
export { ForwardRef as ReactComponent };